import { FC } from 'react';

import { documentCategoryOptions } from '../../../constants/document-category.constant';
import { DocumentCategory } from '../../../enums/document-category.const';
import { MultiSelectFilter, MultiSelectFilterOption } from './multi-select-filter';

const CATEGORY_OPTIONS: MultiSelectFilterOption<DocumentCategory>[] = documentCategoryOptions.map(
  ({ value, labelKey }) => ({ value, labelKey }),
);

type CategoryFilterSelectProps = {
  disabled?: boolean;
  onChange: (value: DocumentCategory[]) => void;
  value: DocumentCategory[];
};

export const CategoryFilterSelect: FC<CategoryFilterSelectProps> = ({
  disabled,
  onChange,
  value,
}) => (
  <MultiSelectFilter
    allOptionLabelKey="FILTER_ALL_CATEGORIES"
    disabled={disabled}
    onChange={onChange}
    options={CATEGORY_OPTIONS}
    placeholderKey="FILTER_ALL_CATEGORIES"
    value={value}
  />
);
